export const URL_API = 'https://gateway.marvel.com:443/v1/public/';

export const PUBLIC_KEY = '60114b4252d585e8c9ac72c1f5d3ad4e';

export const PRIVATE_KEY = '3b3cccdf7f219c6fe78a1b0e8c8c6f314e0e189d';

